import { actions } from './slice';
import { getFacilityByUserId, getAllFacilities, connectToFacility, leaveFacility } from './actions';

const allActions = {
  ...actions,
  getFacilityByUserId,
  getAllFacilities,
  leaveFacility,
  connectToFacility,
};

export { allActions as facilityActions };
export { reducer as facilityReducer } from './slice';
